import { useState } from "react";
import { AccountBlewUpModal } from "./AccountBlewUpModal";
import type { AccountViolation } from "../../trading-journal/operations";

// Module-level Set — persiste entre remontages React (StrictMode, navigation)
// et entre instances du hook sur la même page.
// Réinitialisé uniquement au rechargement complet de la page.
const shownAccountIds = new Set<string>();

/**
 * Hook partagé pour la détection de compte cramé.
 * À utiliser partout où createTrade ou importTradesFromCSV est appelé.
 */
export function useAccountBlewUpModal() {
  const [violationQueue, setViolationQueue] = useState<AccountViolation[]>([]);

  function handleViolation(violation: AccountViolation | undefined | null) {
    if (!violation) return;
    if (shownAccountIds.has(violation.accountId)) return;
    shownAccountIds.add(violation.accountId);
    setViolationQueue((q) => [...q, violation]);
  }

  function handleViolations(violations: AccountViolation[] | undefined | null) {
    if (!violations || violations.length === 0) return;
    const fresh = violations.filter((v) => !shownAccountIds.has(v.accountId));
    if (fresh.length === 0) return;
    fresh.forEach((v) => shownAccountIds.add(v.accountId));
    setViolationQueue((q) => [...q, ...fresh]);
  }

  function dismiss() {
    setViolationQueue((q) => q.slice(1));
  }

  const blewUpModalProps = {
    open: violationQueue.length > 0,
    violation: violationQueue[0] ?? null,
    onConfirm: dismiss,
    onDismiss: dismiss,
  };

  return { handleViolation, handleViolations, blewUpModalProps };
}
